import React from "react";
import { SuccessPaymentIcon } from "icons/payments/successPayment";

interface SuccessScreenProps {
  onViewPlan: () => void;
  onBackToDashboard: () => void;
  id?: string | null;
}

const SuccessScreen: React.FC<SuccessScreenProps> = ({
  onViewPlan,
  onBackToDashboard,
}) => (
  <div className="w-full lg:pt-[150px] pt-[100px] lg:px-0 px-5">
    <div className="w-full flex-col flex items-center justify-center gap-10 text-center">
      <SuccessPaymentIcon />
      <div>
        <p className="lg:text-2xl text-xl font-medium text-txtPrimary">
          Subscription canceled successfully
        </p>
        <p className="lg:pt-6 pt-4 lg:text-base text-sm text-txtParagraph leading-[20.83px]">
          Your subscription has been successfully canceled.
        </p>
      </div>
      <div className="lg:text-base text-sm text-txtParagraph leading-[20.83px]">
        <span
          className="text-blue hover:!text-btnPrimaryHover underline cursor-pointer"
          onClick={onViewPlan}
        >
          Click here
        </span>{" "}
        to view your full plan details.
        <div
          className="lg:text-base text-sm text-blue hover:!text-btnPrimaryHover cursor-pointer lg:pt-10 pt-5"
          onClick={onBackToDashboard}
        >
          Back to dashboard
        </div>
      </div>
    </div>
  </div>
);

export default SuccessScreen;
